import type {Store} from 'vuex';
import type {RootState} from '@/types/RootState';
import {d} from '@/utils/consoleHelper.ts';

export default async function auth({store}: { store: Store<RootState> }) {
    d.log('%c -- MIDDLEWARE -- AUTH ✅', 'color: white;background: green; padding: 2px; font-weight: bold;');

    try {
        // Check if the user is authenticated
        if (!isLoggedIn(store)) {
            d.warn('%c 🚪 User is NOT logged in - Redirecting...', 'color: orange; font-weight: bold;');
            return false;
        }

        d.log('%c 🔓 User is logged in - Loading dynamic routes...', 'color: lime; font-weight: bold;');

        await addDynamicRoutes(store);

        return true;
    } catch (error) {
        d.error('%c ❌ Auth Middleware Error:', 'color: red; font-weight: bold;', error);
        return false;
    }
}

/**
 * Check if the user is logged in
 */
function isLoggedIn(store: Store<RootState>): boolean {
    const token = store.getters['auth/token'];
    d.log('%c 🔑 Auth Token:', 'color: cyan; font-weight: bold;', token);
    return !!token;
}

/**
 * Add dynamic routes
 */
async function addDynamicRoutes(store: Store<RootState>) {
    try {
        const roles = store.getters['auth/roles'];
        const permissions = store.getters['auth/permissions'];

        d.log('%c 🚀 Generating dynamic routes...', 'color: lightblue; font-weight: bold;');
        d.table({roles});
        d.table({permissions});

        await store.dispatch('permission/generateRoutes', {roles, permissions});

        d.log('%c ✅ Dynamic routes added successfully!', 'color: lime; font-weight: bold;');
    } catch (error) {
        d.error('%c ❌ Error adding dynamic routes:', 'color: red; font-weight: bold;', error);
    }
}